export default "__VITE_ASSET__DM0GYe0d__"